import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { usePlatformLeafEventHandler } from '@atlaskit/analytics-next/usePlatformLeafEventHandler';
import Button from '@atlaskit/button/standard-button';
const analyticsAttributes = {
  componentName: 'breadcrumbsItem',
  packageName: "@atlaskit/breadcrumbs",
  packageVersion: "11.2.0"
};

const noop = () => {};

export default /*#__PURE__*/React.forwardRef(({
  hasOverflow = true,
  href = '#',
  onClick: onClickProvided = noop,
  analyticsContext,
  iconBefore,
  iconAfter,
  ...props
}, ref) => {
  const handleClicked = usePlatformLeafEventHandler({
    fn: onClickProvided,
    action: 'clicked',
    analyticsData: analyticsContext,
    ...analyticsAttributes
  });
  return /*#__PURE__*/React.createElement(Button, _extends({
    appearance: "subtle-link",
    spacing: "none",
    iconAfter: hasOverflow ? undefined : iconAfter,
    iconBefore: hasOverflow ? undefined : iconBefore,
    onClick: handleClicked,
    ref: ref,
    href: href
  }, props));
});